import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  width: 100%;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}
function _templateObject4() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n\n  p {\n    color: ",
        ";\n    font-size: 14px;\n    font-weight: 400;\n    line-height: 22px;\n    letter-spacing: -0.14px;\n    text-align: center;\n  }\n"
    ]);
    _templateObject4 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import usePayment from "@/components/Checkout/hooks/usePayment";
import FilledButton from "@/components/common/Button/FilledButton";
import { LoadingFragment } from "@/components/LoadingFragment";
import useSearchParams from "@/hooks/useSearchParams";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { BOOKS_ORDER, EBOOKS_ORDER, HOME_PAGE } from "@/settings/constant";
import { Button } from "@bookips/sds";
import { useQuery } from "@tanstack/react-query";
import Link from "next/link";
import { useRouter } from "next/router";
import { useCallback, useEffect, useMemo, useState } from "react";
import { fetchBooksCart } from "src/api/booksCart";
import useBooksOrderStore from "src/store/booksOrder";
import styled from "styled-components";
import { BooksSubtitle, useBooks } from ".";
import { OrderCardContainer } from "../../Package/OrderComponents/PaymentCard";
import BooksOrderDelivery from "./BooksOrderDelivery";
import BooksOrderModal from "./BooksOrderModal";
import BooksOrderProducts from "./BooksOrderProducts";
import BooksOrderSummary from "./BooksOrderSummary";
export const OrderStack = styled.div.withConfig({
    componentId: "sc-c59ef07b-0"
})(_templateObject());
export const OrderSectionContainer = styled.section.withConfig({
    componentId: "sc-c59ef07b-1"
})(_templateObject1());
export const OrderSectionTitle = styled(BooksSubtitle).withConfig({
    componentId: "sc-c59ef07b-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_700);
export const PaymentContainer = styled.form.withConfig({
    componentId: "sc-c59ef07b-3"
})(_templateObject3());
export const PaymentButtonContainer = styled.div.withConfig({
    componentId: "sc-c59ef07b-4"
})(_templateObject4(), (props)=>props.theme.new.colors.sol_gray_500);
export const OrderSection = (param)=>{
    let { children , label  } = param;
    return /*#__PURE__*/ _jsxs(OrderSectionContainer, {
        children: [
            !!label && /*#__PURE__*/ _jsx(OrderSectionTitle, {
                children: label
            }),
            children
        ]
    });
};
const mixpanelMemoKey = "mixpanel-books-order";
const BooksOrder = ()=>{
    const revision = useBooksOrderStore((state)=>state.revision);
    const items = useBooksOrderStore((state)=>state.items);
    const payableAmount = useBooksOrderStore((state)=>state.payableAmount);
    const { setItems  } = useBooksOrderStore((param)=>{
        let { setItems  } = param;
        return {
            setItems
        };
    });
    const { isBooks  } = useBooks();
    const { cartType , orderType , mixpanelCategory , postbackURL  } = useMemo(()=>{
        return {
            cartType: isBooks ? "aladinbook" : "ebook",
            orderType: isBooks ? 3 : 2,
            mixpanelCategory: isBooks ? "aladin" : "goodnote",
            postbackURL: isBooks ? BOOKS_ORDER : EBOOKS_ORDER
        };
    }, [
        isBooks
    ]);
    const { data , isLoading  } = useQuery([
        "currentBooksCart",
        revision
    ], ()=>fetchBooksCart({
            cartType
        }));
    useEffect(()=>{
        if (!data) {
            setItems(undefined, isBooks);
            return;
        }
        setItems(data.lineItems, isBooks);
    }, [
        data,
        isBooks
    ]);
    const [isShownSuccessModal, setIsShownSuccessModal] = useState(false);
    const handleSuccess = useCallback(()=>{
        setIsShownSuccessModal(true);
        const memo = sessionStorage.getItem(mixpanelMemoKey);
        if (memo && window.mixpanel) {
            const props = JSON.parse(memo);
            mixpanelEvent("Purchase Completed", props);
        }
        sessionStorage.removeItem(mixpanelMemoKey);
    }, []);
    const { ready , paymentHandle  } = usePayment({
        paymentData: data,
        paymentLoading: isLoading,
        orderType: "ebook",
        id: (data === null || data === void 0 ? void 0 : data.id) || ""
    });
    const { pathname , replace  } = useRouter();
    const searchParams = useSearchParams();
    useEffect(()=>{
        const success = searchParams.get("success");
        // 실패의 경우, usePayment에서 처리함.
        if (success) {
            if (success === "true") {
                handleSuccess();
            }
        }
    }, [
        handleSuccess,
        searchParams,
        replace,
        pathname
    ]);
    if (isLoading || !data) {
        return /*#__PURE__*/ _jsx(LoadingFragment, {});
    }
    return /*#__PURE__*/ _jsxs(OrderStack, {
        children: [
            isBooks && /*#__PURE__*/ _jsx(OrderSection, {
                label: "배송지 정보",
                children: /*#__PURE__*/ _jsx(OrderCardContainer, {
                    children: /*#__PURE__*/ _jsx(BooksOrderDelivery, {})
                })
            }),
            /*#__PURE__*/ _jsx(OrderSection, {
                label: "상품 정보",
                children: /*#__PURE__*/ _jsx(BooksOrderProducts, {})
            }),
            !!(items === null || items === void 0 ? void 0 : items.length) && /*#__PURE__*/ _jsx(OrderSection, {
                label: "결제 정보",
                children: /*#__PURE__*/ _jsx(OrderCardContainer, {
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "flex flex-col gap-10",
                        children: [
                            /*#__PURE__*/ _jsx(BooksOrderSummary, {}),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "flex flex-col gap-5",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        id: "payment-method"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        id: "agreement"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(PaymentButtonContainer, {
                                children: [
                                    /*#__PURE__*/ _jsxs(Button, {
                                        variant: "fill",
                                        size: "xl",
                                        onClick: ()=>paymentHandle(),
                                        disabled: !ready,
                                        children: [
                                            payableAmount.toLocaleString(),
                                            "원 결제하기"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        children: "결제 시 약관 및 정보를 확인하였으며 동의한 것으로 간주합니다."
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx(BooksOrderModal, {
                open: isShownSuccessModal,
                title: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        isBooks ? "도서" : "굿노트6 eBook",
                        " 결제가 완료되었습니다.",
                        /*#__PURE__*/ _jsx("br", {}),
                        isBooks ? "배송이 시작되면" : "카카오",
                        " 알림톡으로 안내 드릴게요."
                    ]
                }),
                content: !isBooks && "쏠북에 가입하신 카카오 계정 및 가입한 전화번호가 연결된 카카오 계정에서 알림톡을 확인하실 수 있습니다.",
                footer: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        isBooks && /*#__PURE__*/ _jsx(Link, {
                            href: "https://solvook.channel.io/support-bots/95251",
                            target: "_blank",
                            children: /*#__PURE__*/ _jsx(FilledButton, {
                                type: "text",
                                variant: "soft",
                                children: "추천인 코드 입력하기"
                            })
                        }),
                        /*#__PURE__*/ _jsx(FilledButton, {
                            type: "text",
                            variant: "solid",
                            onClick: ()=>replace(HOME_PAGE),
                            children: "홈으로 돌아가기"
                        })
                    ]
                })
            })
        ]
    });
};
export default BooksOrder;
